import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../action';
import TransferDetails from './components/TransferDetails';

function TransferOfOwnershipContainer({
  createMachineryApplicationTransaction,
  getMachineryApplicationsList,
  history,
  transactionCode,
  createRichTextEditor,
  formData,
  setFormData,
  convertToRaw,
  draftToHtml,
}) {
  const setModal = useContext(ModalContext);

  const RULES = {
    tdn: 'required|rptax_tdn',
    rptax_machinery_owner_id: 'required',
    memoranda: 'required',
  };

  const formValidator = useFormValidator(formData, RULES);

  const validateForm = () => {
    if (!formValidator.response.is_passed) {
      return false;
    }
    return true;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (validateForm() !== true) {
      return false;
    }
    const args = {
      ...formData,
      rptax_transaction_code_id: transactionCode,
      rptax_building_owner_id: formData.rptax_building_owner_id ?? null,
      appraised_assessed_at: `${moment(
        _.get(formData, 'appraised_assessed_at')
      ).format('YYYY-MM-DD HH:mm:00')}`,
      recommending_at: `${moment(_.get(formData, 'recommending_at')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      approved_at: `${moment(_.get(formData, 'approved_at')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      registered: `${moment(_.get(formData, 'registered')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      memoranda: draftToHtml(
        convertToRaw(formData.memoranda.getCurrentContent())
      ),
    };
    createMachineryApplicationTransaction(args, (data) => {
      setModal({ isOpen: false });
      getMachineryApplicationsList();
      history.push(`/rpt/machinery/applications/${_.get(data, 'data.id')}`);
    });
    return false;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="m-1 p-1">
          <TransferDetails
            formData={formData}
            setFormData={setFormData}
            validateForm={formValidator}
            createRichTextEditor={createRichTextEditor}
            transactionCode={transactionCode}
          />
        </div>
      </form>
    </Modal.Body>
  );
}

TransferOfOwnershipContainer.defaultProps = {
  transactionCode: '',
};

TransferOfOwnershipContainer.propTypes = {
  createMachineryApplicationTransaction:
    PropTypes.instanceOf(Function).isRequired,
  getMachineryApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.string,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransferOfOwnershipContainer);
